var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(!!_vm.link ? 'a' : 'button',{tag:"component",class:[
    _vm.buttonSize,
    _vm.style,
    _vm.disabled ? 'cursor-auto' : '',
  ],attrs:{"aria-label":_vm.ariaGlobalLabel,"disabled":_vm.disabled,"href":!!_vm.link ? _vm.link : false,"target":_vm.getTarget,"data-t-name":"icon-button"},on:{"click":function($event){return _vm.click($event)}}},[(!!_vm.icon)?_c('BaseIcon',{attrs:{"name":_vm.icon,"type":_vm.iconType,"classes":_vm.iconSize}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }